import EditablePropsType from '../../../types/composer';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import { faAnalytics } from '@fortawesome/pro-regular-svg-icons/faAnalytics';
import { faBolt } from '@fortawesome/pro-regular-svg-icons/faBolt';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons/faBookmark';
import { faBriefcase } from '@fortawesome/pro-regular-svg-icons/faBriefcase';
import { faCalendarAlt } from '@fortawesome/pro-regular-svg-icons/faCalendarAlt';
import { faClosedCaptioning } from '@fortawesome/pro-regular-svg-icons/faClosedCaptioning';
import { faComments } from '@fortawesome/pro-regular-svg-icons/faComments';
import { faEdit } from '@fortawesome/pro-regular-svg-icons/faEdit';
import { faEnvelope } from '@fortawesome/pro-regular-svg-icons/faEnvelope';
import { faFileAlt } from '@fortawesome/pro-regular-svg-icons/faFileAlt';
import { faFileMedical } from '@fortawesome/pro-regular-svg-icons/faFileMedical';
import { faHandHoldingSeedling } from '@fortawesome/pro-regular-svg-icons/faHandHoldingSeedling';
import { faHeadSideBrain } from '@fortawesome/pro-regular-svg-icons/faHeadSideBrain';
import { faLanguage } from '@fortawesome/pro-regular-svg-icons/faLanguage';
import { faLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faListCheck } from '@fortawesome/pro-regular-svg-icons/faListCheck';
import { faMemoCircleCheck } from '@fortawesome/pro-regular-svg-icons/faMemoCircleCheck';
import { faMobileAlt } from '@fortawesome/pro-regular-svg-icons/faMobileAlt';
import { faMobileScreenButton } from '@fortawesome/pro-regular-svg-icons/faMobileScreenButton';
import { faNotes } from '@fortawesome/pro-regular-svg-icons/faNotes';
import { faSitemap } from '@fortawesome/pro-regular-svg-icons/faSitemap';
import { faStar } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { faTags } from '@fortawesome/pro-regular-svg-icons/faTags';
import { faVideo } from '@fortawesome/pro-regular-svg-icons/faVideo';
import { faXRay } from '@fortawesome/pro-regular-svg-icons/faXRay';

import AddToPlaylistIcon from '../../../components/icons/AddToPlaylistIcon';
import React from 'react';

export const featureIconMap = {
  youtube: faYoutube,
  bolt: faBolt,
  mobile: faMobileAlt,
  link: faLink,
  briefcase: faBriefcase,
  'hand-holding-seedling': faHandHoldingSeedling,
  analytics: faAnalytics,
  tags: faTags,
  file: faFileAlt,
  'head-side-brain': faHeadSideBrain,
  stethoscope: faStethoscope,
  calendar: faCalendarAlt,
  comments: faComments,
  envelope: faEnvelope,
  playlist: <AddToPlaylistIcon />,
  edit: faEdit,
  star: faStar,
  // New FontAwesome icons
  video: faVideo,
  notes: faNotes,
  'memo-circle-check': faMemoCircleCheck,
  language: faLanguage,
  'mobile-screen': faMobileScreenButton,
  listcheck: faListCheck,
  bookmark: faBookmark,
  subtitles: faClosedCaptioning,
  sitemap: faSitemap,
  'file-medical': faFileMedical,
  'x-ray': faXRay,
};

export const columnsSchema = {
  type: EditablePropsType.Array,
  label: 'Columns',
  name: 'columns',
  items: {
    type: EditablePropsType.Array,
    label: 'Column',
    items: {
      type: EditablePropsType.Object,
      properties: {
        title: {
          type: EditablePropsType.Text,
          name: 'title',
          label: 'Title',
        },
        subtitle: {
          type: EditablePropsType.Text,
          name: 'subtitle',
          label: 'Subtitle',
        },
        features: {
          type: EditablePropsType.Array,
          name: 'features',
          label: 'Features',
          items: {
            type: EditablePropsType.Object,
            properties: {
              title: {
                type: EditablePropsType.RichText,
                name: 'title',
                label: 'Text',
              },
              icon: {
                type: EditablePropsType.Object,
                label: 'Icon',
                name: 'icon',
                properties: {
                  name: {
                    type: EditablePropsType.Select,
                    label: 'Name',
                    name: 'name',
                    selectOptions: {
                      options: Object.keys(featureIconMap).map((item) => ({
                        value: item,
                        label: item,
                      })),
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
};

export default columnsSchema;
